import pub from '../public';
const type = pub.getLang();

const language = {
  'zh-hk': {
    renewDate:'樓盤到期日：',
    renewRemain:'剩餘：',
    renewAfter:'續期後的樓盤到期日：',
    renewGo:'是否繼續續期？',
    renewDays:'天',
    renewHours:'小時',
    // post
    nomalImage: `刊登標準盤必須上載至少一張圖片`,
    confirmBtn: '確定',
    cancelBtn: '取消',
    noRenewalText: '因樓盤資料不完整，無法續期樓盤，須先補回填寫資料',
    parNowText: '因樓盤資料不完整，無法付款，須先補回填寫資料',
    stop: '對不起，功能暫時停用',
    maxRenewal: '已達續期上限\n在有效期內樓盤最多續期1次',
    // start: '請前往會員中心上傳您的地產代理證，待確認後功能會重新啟用',
    goEdit: '前往會員中心',
    Page: '頁',
    di: '第',
    Position: '位',
    // 列表
    defaultPage: '參考排名(預設)',
    DistrictPage: '參考排名(地區)',
    landlord: '業主自讓盤',
    Landlord: '業主盤',
    plane: '平面圖',
    OffLine:'已下架',
    agency: '代理盤',
    seal: '封盤',
    rented: '已租',
    sold: '已售',
    isVerifyImg: '樓盤已驗證',
    titleSale: '售盤',
    titleRent: '租盤',
    confirm: '確定',
    cancel: '取消',
    clear: '清空',
    nodata: '找不到所需資料',
    PropertyID: 'House730樓盤編號',
    Redata: '放盤日期',
    Status: '審核狀態',
    exday: '到期日',
    exdayed: '已到期',
    Pushable: '重新推前次數',
    visitorsNum: '瀏覽人次',
    messageNum: '留言數目',
    edit: '更改 >',
    jian: '建',
    chi: '呎',
    wan: '萬',
    yi: '億',
    nomore: '找不到所需资料',
    noHome: '暫時未有符合搜尋條件的樓盤',
    find: '找到',
    num: '個樓盤',
    editProperty: '管理樓盤 - House730',
    editProperty_description: '會員選單',
    loadingText: '加載中',
    super: '超級置頂',
    superPan: '精選盤',
    Standard: '標準盤',
    starPan: '星級盤',
    isVerify: '/樓盤驗證',
    // 详情
    // SalePropertyStatus: [{ text: '封盤', value: '0' }, { text: '待售', value: '1' }, { text: '已售', value: '3' }],
    // RentPropertyStatus: [{ text: '封盤', value: '0' }, { text: '待租', value: '1' }, { text: '已租', value: '3' }],
    rank: '確定重新推前？',
    ranked: '確定後，該樓盤將置於相同放盤類型的最前。',
    selectedprop:'確認刪除已選的樓盤嗎？',
    selectedproped:'刪除後資料將無法復原',
    norank: '沒有重新推前次數可用',
    pstatus: '樓盤狀態',
    noChance: '操作失敗',
    statusSuccess: '状态修改成功',
    statusFail: '状态修改失败',
    pushSuccess: '已成功推盤',
    starPush: '重新推前成功',
    starPushTip: '星級盤參考排名將於稍後更新',
    pushFail: '當前免費重新排序次數已用完。請使用增加曝光或續期',
    infoEdit: '樓盤資料及狀態更改',
    number: '物業編號',
    area: '地區',
    sale: '售價',
    rent: '租價',
    topType: '廣告類型',
    paymentMethod: '付款方式',
    paid: '付費放盤',
    free: '免費放盤',
    active: '審核狀態',
    showORhide: '顯示樓盤',
    show: '顯示樓盤',
    hide: '隱藏樓盤',
    ranking: '地區排序名次',
    recommendNumber: '可重新推前次數',
    pay: '立即付款',
    editPro: '修改樓盤',
    copy: '複製樓盤',
    delete:'刪除樓盤',
    delsus:'刪除成功',
    editActive: '樓盤狀態更改',
    push: '重新推前',
    addLight: '續期',
    alPaid:'已補',
    unPaid:'未補',
    status: {
      wait: '此樓盤尚未生效，正在等候付款',
      Obtained: '被移除',
      passed: '審核通過',
      nopass: '審核不通過',
      passing: '樓盤正在審核中'
    },
    shortRent: '短租',
    shareRent: '分租',
    build: '建',
    real: '實',
    yue: '約',
    beizhu: '收藏備註：',
    tipsKeyWordTop: '服務式住宅放盤另設地產代理套餐，如想了解更多，歡迎與我們聯絡。 Tel: 852-3619 3218',
    keyCon: '確定',
  },
  'zh-cn': {
    renewDate:'楼盘到期日：',
    renewRemain:'剩余：',
    renewAfter:'续期后的楼盘到期日：',
    renewGo:'是否继续续期？',
    renewDays:'天',
    renewHours:'小时',
    nomalImage: `刊登标准盘必须上载至少一张图片`,
    confirmBtn: '确定',
    cancelBtn: '取消',
    noRenewalText: '因楼盘资料不完整，无法续期楼盘，须先补回填写资料',
    parNowText: '因楼盘资料不完整，无法付款，须先补回填写资料',
    OffLine:'已下架',
    Page: '页',
    di: '第',
    Position: '位',
    // post
    maxRenewal: '已达续期上限\n在有效期内楼盘最多续期1次',
    stop: '对不起，功能暂时停用',
    // start: '请前往会员中心上传您的地产代理证，待确认后功能会重新启用',
    goEdit: '前往会员中心',
    landlord: '业主自让盘',
    Landlord: '业主盘',
    plane: '平面图',
    agency: '代理盘',
    seal: '封盘',
    rented: '已租',
    sold: '已售',
    // SalePropertyStatus: [{ text: '封盘', value: '0' }, { text: '待售', value: '1' }, { text: '已售', value: '3' }],
    // RentPropertyStatus: [{ text: '封盘', value: '0' }, { text: '待租', value: '1' }, { text: '已租', value: '3' }],
    defaultPage: '参考排名(预设)',
    DistrictPage: '参考排名(地区)',
    isVerifyImg: '楼盘已验证',
    confirm: '确定',
    cancel: '取消',
    titleSale: '售盘',
    titleRent: '租盘',
    clear: '清空',
    nodata: '找不到所需资料',
    PropertyID: 'House730楼盘编号',
    Redata: '放盘日期',
    Status: '审核状态',
    exday: '到期日',
    exdayed: '已到期',
    Pushable: '重新推前次數',
    visitorsNum: '浏览人次',
    messageNum: '留言数目',
    edit: '更改 >',
    jian: '建',
    chi: '呎',
    wan: '万',
    yi: '亿',
    nomore: '找不到所需資料',
    noHome: '暂时未有符合搜寻条件的楼盘',
    find: '找到',
    num: '个楼盘',
    editProperty: '管理楼盘 - House730',
    editProperty_description: '会员选单',
    loadingText: '加载中',
    super: '超级置顶',
    superPan: '精选盘',
    Standard: '标准盘',
    starPan: '星级盘',
    isVerify: '/楼盘验证',
    // 详情
    rank: '确定重新推前？',
    ranked: '确定后，该楼盘将置于相同放盘类型的最前。',
    selectedprop:"确认删除已选的楼盘吗？",
    selectedproped:"删除后资料将无法复原",
    norank: '没有重新置顶次数可用',
    status: {
      wait: '此楼盘尚未生效，正在等候付款',
      Obtained: '被移除',
      passed: '审核通过',
      nopass: '审核不通过',
      passing: '楼盘正在审核中'
    },
    pstatus: '楼盘状态',
    noChance: '操作失败',
    statusSuccess: '状态修改成功',
    statusFail: '状态修改失败',
    pushSuccess: '已成功推盘',
    starPush: '重新置顶成功',
    starPushTip: '星级盘参考排名将于稍后更新',
    pushFail: '当前免费重新排序次数已用完。请使用增加曝光或续期',
    infoEdit: '楼盘资料及状态更改',
    number: '物业编号',
    area: '地区',
    sale: '售价',
    rent: '租价',
    topType: '广告类型',
    paymentMethod: '付款方式',
    paid: '付费放盘',
    free: '免费放盘',
    active: '审核状态',
    showORhide: '显示楼盘',
    show: '显示楼盘',
    hide: '隐藏楼盘',
    ranking: '地区排序名次',
    recommendNumber: '可重新推前次数',
    pay: '立即付款',
    editPro: '修改楼盘',
    copy: '复制楼盘',
    delete:'删除楼盘',
    delsus:'删除成功',
    editActive: '楼盘状态更改',
    push: '重新推前',
    addLight: '续期',
    alPaid:'已补',
    unPaid:'未补',
    shortRent: '短租',
    shareRent: '分租',
    build: '建',
    real: '实',
    yue: '约',
    beizhu: '收藏备注：',
    tipsKeyWordTop: '服务式住宅放盘另设地产代理套餐，如想了解更多，欢迎与我们联络。 Tel: 852-3619 3218',
    keyCon: '确定',
  },
  'en-us': {
    renewDate:'Listing Expiry Date:',
    renewRemain:'Remaining:',
    renewAfter:'Listing Expiry Date after renewal:',
    renewGo:'Are you going to Renew?',
    renewDays:'Days',
    renewDay:'Day',
    renewHours:'Hours',
    renewHour:'Hour',
    nomalImage: 'Standard Listing - Upload at least 1 photo',
    confirmBtn: 'OK',
    cancelBtn: 'Cancel',
    noRenewalText: 'Due to the incomplete property information, the property cannot be renewed, and the information must be filled in first',
    parNowText: 'Due to incomplete property information, payment cannot be made, and the information must be filled in first',
    Page: 'Page',
    di: '',
    Position: 'Position',
    // post
    maxRenewal: 'Limit Reached \n Can only renew 1 times before expired',
    stop: 'Sorry, function temporary suspended',
    // start: 'Please go to Member Centre and upload your Estate Agent card, function will be resumed after confirmation',
    defaultPage: 'Ref. Ranking (Default)',
    DistrictPage: 'Ref. Ranking (District)',
    goEdit: 'Go to Member Centre',
    landlord: 'Landlord',
    Landlord: 'Landlord',
    plane: 'Floor Plan',
    OffLine:'Unpublished',
    agency: 'Agency',
    noHome: 'No matched listing property found temporarily',
    seal: 'Closed',
    rented: 'Rented',
    sold: 'Sold',
    // SalePropertyStatus: [{ text: 'Closed', value: '0' }, { text: 'For Sale', value: '1' }, { text: 'Sold Out', value: '3' }],
    // RentPropertyStatus: [{ text: 'Closed', value: '0' }, { text: 'For Rent', value: '1' }, { text: 'Leased Out', value: '3' }],
    isVerifyImg: 'Verified',
    confirm: 'OK',
    cancel: 'Cancel',
    noChance: 'operation failed',
    titleSale: 'Sale',
    titleRent: 'Rent',
    clear: 'Empty',
    nodata: 'No results found',
    nomore: 'No results found',
    PropertyID: 'House730 ID',
    Redata: 'Listing Date',
    Status: 'Status',
    exday: 'Expiry Date',
    exdayed: 'Expired',
    Pushable: 'Push Forward times',
    visitorsNum: 'View',
    messageNum: 'Message:',
    edit: 'Edit>',
    jian: 'Build',
    chi: 'sq. ft',
    wan: 'M',
    find: '',
    num: ' properties found',
    editProperty: 'Manage My Properties - House730',
    editProperty_description: 'Member Menu',
    loadingText: 'loading',
    super: 'Super',
    Standard: 'Standard',
    isVerify: '/Verified Service',
    superPan: 'Featured',
    starPan: 'Premium Listing',
    // details
    rank: 'Confirm to push forward?',
    ranked: 'Your property will be re-ranked at the top for same type of listing',
    selectedprop:'Confirm clear selected property?',
    selectedproped:'Deleted information cannot be recoverd',
    norank: 'No more push forward available',
    status: {
      wait: 'Property Listing not yet effective, pending payment',
      Obtained: 'Removed by admin',
      passed: 'Listing is approved',
      nopass: 'Listing is not approved',
      passing: 'Listing is under review'
    },
    pstatus: 'Property Status',
    statusSuccess: 'Status modified successfully',
    statusFail: 'Status modification failed',
    pushSuccess: 'Your property has been re-positioned at the top',
    starPush: 'Your property has been re-positioned at the top',
    starPushTip: 'Premium Listing Ref. Ranking will be updated soon',
    pushFail: 'The current free reordering count has been exhausted. Please use increase exposure or renewal',
    infoEdit: 'Property data and status changes',
    number: 'Property ID',
    area: 'Area',
    sale: 'Selling Price',
    rent: 'rental price',
    topType: 'Listing Method',
    paymentMethod: 'Payment Method',
    paid: 'Paid Listing',
    free: 'Free listing',
    active: 'Status',
    showORhide: 'Visibility',
    show: 'Show property',
    hide: 'Hidden property',
    ranking: 'Ranking in area',
    recommendNumber: 'Push Forward times available',
    pay: 'Pay Now',
    editPro: 'Edit',
    copy: 'Copy Property',
    delete:'Delete',
    delsus:'Delete Successfully',
    push: 'Push Forward',
    editActive: 'Update Property Status',
    addLight: 'Re-new',
    alPaid:'Prem. paid',
    unPaid:'Prem. unpaid',
    shortRent: 'Short-term',
    shareRent: 'Share',
    build: 'Saleable',
    real: 'Gross',
    yue: 'Approx.',
    beizhu: 'Bookmark Property Notes:',
    tipsKeyWordTop: 'There is Property Agent Package for the listing of Serviced Apartment. If you would like to know more about Property Agent Package, please contact us。 Tel: 852-3619 3218。',
    keyCon: 'OK',
  }
};
export default language[type];
